import { render, staticRenderFns } from "./DSkillsDrag.vue?vue&type=template&id=7bdbf374&scoped=true&"
import script from "./DSkillsDrag.vue?vue&type=script&lang=js&"
export * from "./DSkillsDrag.vue?vue&type=script&lang=js&"
import style0 from "./DSkillsDrag.vue?vue&type=style&index=0&id=7bdbf374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdbf374",
  null
  
)

export default component.exports